import type { RouteRecordRaw } from 'vue-router'

import type { PanelKind } from './utils/panels'

/**
 * The admin module's routes (WP-19, wp/admin §3): the three back-office account lists, one view (§1.1). Paths and
 * names from the route manifest (D-15); legacy `/admin/employee` reaches `/admin/employees` through the generated
 * `src/app/router/legacy-redirects.ts`. Production keeps its HTTP Basic gate on any `/admin` URI (`public/
 * .htaccess_prod`, OPEN-4) — full page loads only.
 *
 * Full layout, no software, no ACL resource: any session mounts the page and the API answers 403 to everyone but the
 * platform administrators (OPEN-1 (a), FX-068 — no flag in the login answer to guard with yet; queued). No `pageTitle`
 * or `breadcrumb`: the full layout never showed legacy's ("Dashboard", "Client List", NEW-4).
 */
const AccountListView = () => import('./views/AccountListView.vue')

function panel(path: string, name: string, kind: PanelKind): RouteRecordRaw {
  return {
    path,
    name,
    component: AccountListView,
    props: { panel: kind },
    meta: { layout: 'full' },
  }
}

const routes: RouteRecordRaw[] = [
  panel('/admin/clients', 'admin-clients', 'clients'),
  panel('/admin/employees', 'admin-employee', 'employees'),
  panel('/admin/staff', 'admin-staff', 'staff'),
]

export default routes
